import { Component, Input, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbDialogRef, NbCardModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { KPI } from '../../../@core/api';
import { AssetTypeSelectorComponent, AssetTypeWithHierarchy } from './asset-type-selector.component';

@Component({
  selector: 'app-asset-type-selector-page',
  templateUrl: './asset-type-selector-page.component.html',
  styleUrls: ['./asset-type-selector-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    NbCardModule,
    TranslateModule,
    AssetTypeSelectorComponent
  ]
})
export class AssetTypeSelectorPageComponent {
  @Input() public searchMode: boolean = false;
  @Input() public parent: KPI.Asset | null = null;
  @Input() public autoSelectAssetTypeId: number = 0;
  @Input() public autoSelectSubCategoryId: number = 0;
  @Input() public autoSelectCategoryId: number = 0;
  @Input() public preventAssetTypesThatNeedParent: boolean = false;

  constructor(
    @Optional() private dialogRef: NbDialogRef<AssetTypeSelectorPageComponent>
  ) {
    const context = (this.dialogRef as any)?.context || {};
    if (context.parent) {
      this.parent = context.parent;
    }
    if (context.autoSelectAssetTypeId) {
      this.autoSelectAssetTypeId = context.autoSelectAssetTypeId;
    }
    if (context.autoSelectSubCategoryId) {
      this.autoSelectSubCategoryId = context.autoSelectSubCategoryId;
    }
    if (context.autoSelectCategoryId) {
      this.autoSelectCategoryId = context.autoSelectCategoryId;
    }
    if (context.preventAssetTypesThatNeedParent !== undefined) {
      this.preventAssetTypesThatNeedParent = context.preventAssetTypesThatNeedParent;
    }
  }

  public close(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  public onAssetTypeSelected(selectedAssetType: AssetTypeWithHierarchy): void {
    if (this.dialogRef) {
      this.dialogRef.close(selectedAssetType);
    }
  }
}

